<div class="drawer lg:drawer-open">
  <input
    id="aside-drawer"
    type="checkbox"
    class="drawer-toggle"
    [(ngModel)]="showDrawer"
  />
  <div class="drawer-content flex flex-col min-h-screen">
    <!-- Navbar -->
    @if (user$ | async) {
      <app-nav-top-secure (toggleDrawer)="toggleDrawer()"></app-nav-top-secure>
    } @else {
      <app-nav-top-public (toggleDrawer)="toggleDrawer()"></app-nav-top-public>
    }
    <!-- Page content here -->
    <div class="flex-grow">
      <router-outlet></router-outlet>
    </div>
    <!-- Footer -->
    <app-footer></app-footer>
  </div>
  <div
    class="drawer-side"
    style="scroll-behavior: smooth; scroll-padding-top: 5rem"
  >
    <label
      for="aside-drawer"
      aria-label="close sidebar"
      class="drawer-overlay"
    ></label>
    <aside class="bg-base-100 min-h-screen w-80">
      <div
        class="bg-base-100 sticky top-0 z-20 hidden items-center gap-2 bg-opacity-90 px-4 py-2 backdrop-blur lg:flex"
      >
        <app-aside-header></app-aside-header>
      </div>
      <app-nav-aside
        [pt]="'pt-2'"
        [dataUrl]="environment.api.data.navigationGuest"
      ></app-nav-aside>
    </aside>
  </div>
</div>
